export const forums = {
  forumsSearchInputPlaceholder: 'Suchen',
  forumsFollowDiscussionButtonTitle: 'Folgen',
  forumsFollowingDiscussButtonTitle: 'Folge',
  forumDiscussionInfoNoReplyText: 'Noch keine Antworten',
  forumsDiscussionDetailsStartButtonTitle: 'Diskussion starten',
  forumDetailsCreatedByText: 'von',
  forumsDiscussionDetailsUsersCurtainCopyOptionTitle: 'Link kopieren',
  forumsDiscussionDetailsUsersCurtainFlagOptionTitle: 'Melden',
  forumsReportedCurtainContent: 'Inhalt gemeldet',
  forumsDiscussionDetailsUserCurtainCopiedAlertText: 'Link kopiert!',
  forumsDiscussionDetailsOwnersCurtainPinOptionTitle: 'Diskussion anheften',
  forumsDiscussionDetailsOwnersCurtainUnpinOptionTitle: 'Diskussion lösen',
  forumsDiscussionDetailsOwnersCurtainEditOptionTitle: 'Diskussion bearbeiten',
  forumsDiscussionDetailsOwnersCurtainDeleteOptionTitle: 'Diskussion löschen',
  forumsDiscussionDetailspPopupDeleteTitle: 'Löschen',
  forumsDiscussionDetailspPopupDeleteText: 'Diese Diskussion löschen?',
  forumsDiscussionDetailspPopupCancelButtonTitle: 'Abbrechen',
  forumsDiscussionDetailspPopupConfirmButtonTitle: 'Bestätigen',
  forumsDiscussionDetailsDeleledAlertText: 'Diskussion gelöscht!',
  forumsNewDiscussionTitle: 'Neue Diskussion',
  forumsNewDiscussionTitlePlaceholder: 'Titel...',
  forumsNewDiscussionBodyPlaceholderText: 'Geben Sie Ihren Text hier ein...',
  forumsNewDiscussionPublishButtonTitle: 'Veröffentlichen',
  forumsNewDiscussionLocationCurtainTitle: 'Ort',
  forumsNewDiscussionLocationCurtainInputPlaceholder: 'Ortsname',
  forumsNewDiscussionEditLocationCurtainText: 'Ort bearbeiten',
  forumsNewDiscussionDeleteLocationCurtainText: 'Ort löschen',
  forumsNewDiscussionCreatePollTitle: 'Umfrage erstellen',
  forumsNewDiscussionTitleInputPlaceholder: 'Titel',
  forumsNewDiscussionOptionInputPlaceholder: 'Option',
  forumsNewDiscussionAddButtonTitle: 'Option hinzufügen',
  forumsNewDiscussionCreateButtonTitle: 'Erstellen',
  forumsNewDiscussionPollTitleBlankAlertText: 'Titel darf nicht leer sein!',
  forumsNewDiscussionPollOptionBlankAlertText: 'Option darf nicht leer sein!',
  forumsNewDiscussionPollLongTitleAlertText: 'Titel darf maximal 140 Zeichen enthalten',
  forumsNewDiscussionPollLongOptionAlertText: 'Option darf maximal 25 Zeichen enthalten',
  forumsNewDiscussionEditPollIconText: 'Umfrage bearbeiten',
  forumsNewDiscussionRemovePollIconText: 'Umfrage entfernen',
  forumsDiscardDraftPopupTitle: 'Entwurf verwerfen',
  forumsDiscardDraftPopupText: 'Diesen Entwurf verwerfen?',
  forumsDiscardDraftPopupCancelButtonTitle: 'Abbrechen',
  forumsDiscardDraftPopupConfirmButtonTitle: 'Bestätigen',
  forumsDiscussionDetailsPostBodyReplyIconTitle: 'Antworten',
  forumsDiscussionDetailsNoCommentsText: 'Es gibt noch keine Kommentare\nSie können der Erste sein',
  forumsDiscussionDetailsReplyInputPlaceholder: 'Antworten',
  forumsDiscussionDetailsPostShareCurtainOptionTitle: 'Link kopieren',
  forumsDiscussionDetailsPostShareCopiedAlertText: 'Link kopiert!',
  forumsDiscussionDetailsPostUsersCurtainFlagOptionTitle: 'Melden',
  forumsDiscussionDetailsPostCurtainReportedText: 'Inhalt gemeldet',
  forumsDiscussionDetailsCommentReplyIconTitle: 'Antworten',
  forumsEditDiscussionTitle: 'Diskussion bearbeiten',
  forumsEditDiscussionSaveButtonTitle: 'Speichern',
  forumsEditedDiscussionSavedAlertText: 'Diskussion gespeichert!',
  forumsDiscussionDetailsOwnersCommentCurtainEditOptionTitle: 'Antwort bearbeiten',
  forumsDiscussionDetailsOwnersCommentCurtainDeleteOptionTitle: 'Antwort löschen',
  forumsDiscussionDetailsEditedCommSavedAlertText: 'Kommentar gespeichert!',
  forumsDiscussionDetailsEditedCommDeletedAlertText: 'Kommentar gelöscht!',
  forumsAlertSomethinWrong: 'Etwas ist schief gelaufen!',
  forumsMaxMbSize: 'Sie können maximal {size} MB auf einmal hochladen',
  forumsMaxAttachments: 'Sie haben die maximale Anzahl an Anhängen überschritten. Maximale Anzahl an Anhängen beträgt {max}',
  forumsDiscussionDetailsDeleteCommentPopupTitle: 'Löschen',
  forumsDiscussionDetailsDeleteCommentPopupText: 'Diesen Kommentar löschen?',
  forumsDiscussionDetailsDeleteCommentPopupCancelButtonTitle: 'Abbrechen',
  forumsDiscussionDetailsDeleteCommentPopupConfirmlButtonTitle: 'Bestätigen',
  forumsDiscussionDetailsUsersCommentCurtainFlagOptionTitle: 'Melden',
  forumsDiscussionDetailsCommentReportedCurtainText: 'Inhalt gemeldet',
  forumDiscussionInfoLastReplyText: 'Letzte Antwort',
  forumsDiscussionAt: 'um',
  forumsDiscussionDetailsFlagCurtainTitle: 'Melden',
  forumsDiscussionDetailsFlaggedReportedCurtainContent: 'Inhalt gemeldet',
  forumsPollInfoVotesText: 'Stimmen',
  forumsPollInfoEditVoteText: 'Stimme bearbeiten',
  forumsPollFinishPollText: 'Umfrage abschließen',
  forumsPollFinishedPollText: 'Abgeschlossen',
  forumsPollInProgresslText: 'In Bearbeitung',
  forumsPollCurtainTitle: 'Umfrage abschließen',
  forumsPollCurtainText: 'Benutzer können nach Abschluss der Umfrage nicht mehr abstimmen.',
  forumsFinishPollCurtainCancelButtonTitle: 'Abbrechen',
  forumsFinishPollCurtainConfirmlButtonTitle: 'Bestätigen',
  forumsPollInfoPollVotesCurtainTitle: 'Umfragestimmen'
}
